import { render, staticRenderFns } from "./SubdomainError404Component.vue?vue&type=template&id=266ff1fe&"
import script from "./SubdomainError404Component.vue?vue&type=script&lang=js&"
export * from "./SubdomainError404Component.vue?vue&type=script&lang=js&"
import style0 from "./SubdomainError404Component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports